import React, { useEffect, useRef, useState } from "react";
import CustomSpan from "../../components/CustomSpan";
import Table from "../../components/table/Table";
import { FiUser, FiCalendar } from "react-icons/fi";
import { FormGroupInput } from "../form/groups";
import { Label } from "../form/labels";
import ExpandablePanel from "../../components/ExpandablePanel";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../modal/Modal";
import tenkenTheme from "../../configs/themes/tenkenTheme";
import { Button } from "flowbite-react";
import { InspectionCard } from "../cards/InspectionCard";
import {
  formatDate,
  formatDateTime,
} from "../../utils/datetime-utils";
import CalendarIcon from "../../assets/icons/calendar-big-icon.svg";
import SettingIcon from "../../assets/icons/setting-big-icon.svg";
import PageEditIcon from "../../assets/icons/page-edit-icon.svg";
import VerifyUserIcon from "../../assets/icons/verified-user-icon.svg";
import { ButtonUpdate, ButtonCloseModal } from "../buttons";
import { Tabs } from "flowbite-react";
import ReadonlyComment from "../ReadonlyComment";
import { fetchInspectionStatusDetail } from "../../api/status/inspection-apis";
import {
  getInspectionResutlBackground,
  getInspectionResutlColor,
  getInspectionResutlSymbol,
} from "../../utils/display-utils";
import {
  InspectionItemDescription,
  InspectionItemResult,
  InspectionItemTitle,
  JudgmentResultText,
  LimitInputValue,
  TreatmentItemResultRow,
} from "./inspection-items";
import RemarkDetail from "../inspection/RemarkDetail";
import { useNavigate } from "react-router-dom";
import { REGISTER_TREATMENT } from "../../constants/routes";
import store from "../../store";
import {
  clearComponentLoading,
  setComponentLoading,
} from "../../store/actions";
import { useTableInspectionItemsScroll } from "../../hooks";
import LoadingSpinner from "../../components/loading/LoadingSpinner";
import { JudgmentStatusInModal } from "../judgment";

function ModalInspection({
  showModal,
  setShowModal,
  inspection,
  workflow,
  onClose,
}) {
  const resultField = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_field
  );
  const resultSymbolSetting = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_symbol
  );
  const [inspections, setInspections] = useState([]);
  const [information, setInformation] = useState({});
  const [treatments, setTreatments] = useState(null);
  const [judgments, setJudgments] = useState(null);
  const [judgmentStatus, setJudgmentStatus] = useState(null);
  const [inspectionItems, setInspectionItems] = useState(null);
  const [maxHeightTableTreatment, setMaxHeightTableTreatment] = useState({});
  const [tabTreatment, setTabTreatment] = useState(1);
  const [activeTab, setActiveTab] = useState(null);
  const tabRef = useRef(null);
  const tableInspectionRef = useRef(null);
  const tableTreatmentRef = useRef({'tab_1': React.createRef()});
  const maxHeightTableInspection = useTableInspectionItemsScroll(tableInspectionRef, inspectionItems);


  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = store.getState().auth;
  useEffect(() => {
    if (inspection && workflow) {
      dispatch(setComponentLoading("inspection-modal"));
      const params = {
        inspection: inspection,
        workflow: workflow,
      };
      fetchInspectionStatusDetail(params)
        .then((response) => {
          const data = response.data;
          setInformation(data.information);
          setInspectionsData(data.inspections, data.treatments);
          setTreatments(data.treatments);
          setJudgments(data.judgments);
          setJudgmentStatus(data.judgments_status);
          setInspectionItems(data.inspection_items);
        })
        .catch((e) => {})
        .finally(() => {
          dispatch(clearComponentLoading("inspection-modal"));
        });
    }
  }, [inspection, workflow]);

  const urlTreatment = (inspectionId) =>
    REGISTER_TREATMENT.replace(":inspectionId", inspectionId);

  const handleRedirectTreatment = (inspection) => {
    navigate(urlTreatment(inspection?.id), { state: { type: "inspectionStatus" } });
  };

  useEffect(() => {
    const refKey = `tab_${tabTreatment}`;
    if (!tableTreatmentRef.current[refKey]?.current) {
      setMaxHeightTableTreatment((prev) => ({
        ...prev,
        [refKey]: 0
      }));
      return;
    }

    const currentRef = tableTreatmentRef.current[refKey]?.current;
    const thead = currentRef.querySelector("thead");
    const theadHeight = thead ? thead.offsetHeight : 0;
    const rows = currentRef.querySelectorAll("tbody tr");


    if (rows.length < 11) {
      setMaxHeightTableTreatment((prev) => ({
        ...prev,
        [refKey]: 0
      }));
      return;
    }

    let rowsHeight = 0;
    for (let i = 0; i < Math.min(10, rows.length); i++) {
      rowsHeight += rows[i].offsetHeight;
    }
    setMaxHeightTableTreatment((prev) => ({
      ...prev,
      [refKey]: theadHeight + rowsHeight
    }));
  }, [tabTreatment, treatments]);

  const setInspectionsData = (inspections, treatments) => {
    tabRef.current?.setActiveTab(inspections.length - 1);
    const newInspections = inspections.map((inspection) => {
      const inspectionStartDatetime = inspection.inspection_start_datetime
        ? formatDate(inspection.inspection_start_datetime)
        : "";
      const operationStartDatetime = inspection.operation_start_datetime
        ? formatDate(inspection.operation_start_datetime)
        : "";
      const operationStartUserId = inspection.operation_start_user?.name;
      const inspectionStartUserId = inspection.inspection_start_user?.name;
      const inspectionResultNG = inspection?.result === 0;
      const hasTreatment =
        Array.isArray(treatments[inspection.id]) &&
        treatments[inspection.id].length > 0;
      return {
        ...inspection,
        inspection_start_datetime: inspectionStartDatetime,
        operation_start_datetime: operationStartDatetime,
        operation_start_user_id: operationStartUserId,
        inspection_start_user_id: inspectionStartUserId,
        inspection_result_ng: inspectionResultNG,
        has_treatment: hasTreatment,
      };
    });
    setInspections(newInspections);
  };

  return (
    <Modal
      dismissible={false}
      show={showModal}
      theme={tenkenTheme}
      position="top-right"
      size="7xl"
      className="relative hide-close custom-modal-size-8xl"
      onClose={() => {
        onClose();
        setShowModal(false);
      }}
    >
      <div className="w-fit min-w-full">
        <LoadingSpinner component="inspection-modal" />
        <Modal.Header className="flex justify-end px-[12px] py-[8px] bg-[#EEE] w-full border-none">
          <ButtonCloseModal onClick={() => {
            onClose();
            setShowModal(false);
          }}>
          </ButtonCloseModal>
        </Modal.Header>
        <Modal.Body className="bg-[#FAFAFA] px-[24px] py-[30px]">
          <div className="flex items-center justify-between gap-4 self-stretch mb-[24px] min-w-[1060px]">
            <InspectionCard
              title={"点検結果登録時間"}
              className="w-[240px]"
              detail={formatDate(
                information?.registration_datetime
              )}
              width="w-[132px]"
              imgSrc={CalendarIcon}
            />
            <InspectionCard
              title="設備No."
              className="min-w-[300px]"
              detail={information?.machine_name}
              imgSrc={SettingIcon}
            />
            <InspectionCard
              title={"点検テンプレート名"}
              className="min-w-[300px]"
              detail={information?.template_name}
              imgSrc={PageEditIcon}
            />
            <InspectionCard
              title={"ユーザー"}
              className="min-w-[300px]"
              detail={auth.user.name}
              imgSrc={VerifyUserIcon}
            />
          </div>
          <Tabs
            style="underline"
            theme={tenkenTheme.modal_inspection_tabs}
            ref={tabRef}
            onActiveTabChange={(tab) => setActiveTab(tab)}
          >
            {inspections.map((inspectionDetails, index) => (
              <Tabs.Item
                title={`点検履歴${inspectionDetails?.inspection_number}回目`}
                key={index}
                active={index === activeTab}
              >
                <div className="w-full flex justify-between pl-[20px] mb-[32px]">
                  <div className="flex">
                    <p className="text-[22px] font-normal">
                      <span className="whitespace-nowrap">点検結果： </span>
                      <span
                        className="inline-block px-2"
                        style={{
                          color: getInspectionResutlColor(
                            inspectionDetails?.result,
                            resultSymbolSetting
                          ),
                          background: getInspectionResutlBackground(
                            inspectionDetails?.result,
                            resultSymbolSetting
                          ),
                        }}
                      >
                        {getInspectionResutlSymbol(
                          inspectionDetails?.result,
                          resultSymbolSetting
                        )}
                      </span>
                    </p>
                    {inspectionDetails?.result === 0 && (
                      <ButtonUpdate
                        className="min-w-[200px] ml-10"
                        onClick={() => handleRedirectTreatment(inspectionDetails)}
                      >
                        <span>処置</span>
                      </ButtonUpdate>
                    )}
                  </div>
                  {judgmentStatus[inspectionDetails.id]?.judgments.length <=
                    5 && (
                    <JudgmentStatusInModal
                      className="overflow-x-auto ml-10"
                      judgmentStatus={
                        judgmentStatus[inspectionDetails.id]?.judgments
                      }
                      inspectionId={inspectionDetails.id}
                      workflowId={workflow}
                      workflowName={information?.workflow_name}
                    />
                  )}
                </div>
                {judgmentStatus[inspectionDetails.id]?.judgments.length > 5 && (
                  <JudgmentStatusInModal
                    className="mb-8"
                    judgmentStatus={
                      judgmentStatus[inspectionDetails.id]?.judgments
                    }
                    inspectionId={inspectionDetails.id}
                    workflowId={workflow}
                    workflowName={information?.workflow_name}
                  />
                )}
                <div className="flex flex-col w-full gap-[32px] max-w-[1674px] min-w-[1060px]">
                  <ExpandablePanel title="点検結果">
                      <div className="w-full relative rounded-lg border border-[#e0e0e0] overflow-y-auto" style={{
                        maxHeight: maxHeightTableInspection ? `${maxHeightTableInspection}px` : "auto"
                      }} ref={tableInspectionRef}>
                      <Table className="no-drop-shadow-table" striped>
                        <Table.Head className={`${maxHeightTableInspection ? 'sticky top-0 z-[8]' : ''} border-b border-tenken-gray-200`}>
                          <Table.HeadCell className="!normal-case w-[2%] min-w-[75px] scrollable-table-header-bg">
                            <span>No.</span>
                          </Table.HeadCell>
                          <Table.HeadCell className="max-w-[938px] scrollable-table-header-bg px-1">
                            <span className="whitespace-nowrap">点検項目</span>
                          </Table.HeadCell>
                          <Table.HeadCell className="scrollable-table-header-bg px-1">
                            <span className="whitespace-nowrap">判定基準</span>
                          </Table.HeadCell>
                          <Table.HeadCell className="scrollable-table-header-bg px-1">
                            <span className="whitespace-nowrap">下限</span>
                          </Table.HeadCell>
                          <Table.HeadCell className="scrollable-table-header-bg px-1">
                            <span className="whitespace-nowrap">上限</span>
                          </Table.HeadCell>
                          <Table.HeadCell className="scrollable-table-header-bg px-1"></Table.HeadCell>
                          <Table.HeadCell className="scrollable-table-header-bg px-1">
                            <span className="whitespace-nowrap">留意事項</span>
                          </Table.HeadCell>
                          <Table.HeadCell className="scrollable-table-header-bg px-1">
                            <span className="whitespace-nowrap">点検結果</span>
                          </Table.HeadCell>
                        </Table.Head>
                        <Table.Body className="devide-y text-base break-all">
                          {inspectionItems?.map((item, i) => (
                            <Table.Row
                              key={i}
                              className="odd:bg-gray-50 even:bg-white odd:dark:bg-gray-70 even:dark:bg-gray-800 border-b border-tenken-gray-200 px-1"
                            >
                              <Table.Cell>
                                <span>{item?.item_order}</span>
                              </Table.Cell>
                              <Table.Cell className="px-1 max-w-[360px]">
                                <InspectionItemTitle item={item} />
                              </Table.Cell>
                              <Table.Cell className="px-1">
                                <InspectionItemDescription item={item} />
                              </Table.Cell>
                              <Table.Cell className="px-1 min-w-[100px]">
                                {item?.inspection_item_type === "input" &&
                                  (item.inspection_judgment ? (
                                    <LimitInputValue
                                      itemJudgment={item.inspection_judgment}
                                      unit={item.unit}
                                      type="lower"
                                    />
                                  ) : (
                                    "-"
                                  ))}
                                {item?.inspection_item_type === "checkbox" && (
                                  <span>-</span>
                                )}
                              </Table.Cell>
                              <Table.Cell className="px-1 min-w-[100px]">
                                {item?.inspection_item_type === "input" &&
                                  (item.inspection_judgment ? (
                                    <LimitInputValue
                                      itemJudgment={item.inspection_judgment}
                                      unit={item.unit}
                                      type="upper"
                                    />
                                  ) : (
                                    "-"
                                  ))}
                                {item?.inspection_item_type === "checkbox" && (
                                  <span>-</span>
                                )}
                              </Table.Cell>
                              <Table.Cell className="px-0.5 min-w-[40px]">
                                <span className="whitespace-nowrap">
                                  {item.unit ? `(${item.unit})` : "-"}
                                </span>
                              </Table.Cell>
                              <Table.Cell className="px-1">
                                <RemarkDetail rowData={item} />
                              </Table.Cell>
                              <Table.Cell className="max-w-[13%] w-full">
                                <InspectionItemResult
                                  items={inspectionDetails.items}
                                  itemOrder={item.item_order}
                                />
                              </Table.Cell>
                            </Table.Row>
                          ))}
                        </Table.Body>
                      </Table>
                    </div>
                    <div className="relative rounded-lg border border-[#e0e0e0] w-full">
                      <Table className="no-drop-shadow-table" striped>
                        <Table.Head className="whitespace-nowrap border-b border-tenken-gray-200">
                          <Table.HeadCell className="w-[40%] !bg-white">
                            <span>点検者情報</span>
                          </Table.HeadCell>
                          <Table.HeadCell className="!bg-white"></Table.HeadCell>
                        </Table.Head>
                        <Table.Body className="devide-y text-base whitespace-nowrap">
                          {resultField && Object.keys(resultField).length > 0
                            ? Object.entries(resultField).map(
                                ([key, title], index) =>
                                  key !== "registration_datetime" && (
                                    <Table.Row
                                      key={index}
                                      className="odd:bg-gray-50 even:bg-white odd:dark:bg-gray-70 even:dark:bg-gray-800 border-b border-tenken-gray-200"
                                    >
                                      <Table.Cell>
                                        <span className="tenken__text-gray-900">
                                          {title}
                                        </span>
                                      </Table.Cell>
                                      <Table.Cell>
                                        <FormGroupInput className="!flex-col">
                                          <FormGroupInput className="gap-[20px]">
                                            <CustomSpan
                                              text={
                                                inspectionDetails
                                                  ? inspectionDetails[key]
                                                  : ""
                                              }
                                              className="tenken__text-gray-900"
                                            ></CustomSpan>
                                          </FormGroupInput>
                                        </FormGroupInput>
                                      </Table.Cell>
                                    </Table.Row>
                                  )
                              )
                            : null}
                        </Table.Body>
                      </Table>
                    </div>
                    <div className="flex flex-col bg-[#FFF] items-start self-stretch w-full xl:gap-[16px] gap-[12px]">
                      <Label className="font-medium" text="点検コメント" />
                      <ReadonlyComment
                        remarkText={inspectionDetails?.remark_text}
                        commentFiles={inspectionDetails?.inspection_comment_files}
                      />
                    </div>
                  </ExpandablePanel>

                  <ExpandablePanel title="処置結果">
                    {/* eslint-disable-next-line react/style-prop-object */}
                    {inspectionDetails?.has_treatment ? (
                      <Tabs
                        style="underline"
                        theme={tenkenTheme.treatment_tabs}
                        onActiveTabChange={
                          (tab) => {
                            setTabTreatment(tab + 1);
                          }
                        }
                      >
                        {treatments[inspectionDetails.id].map((treatment) => (
                          <Tabs.Item
                            title={`処置${treatment.treatment_number}回目`}
                            active={tabTreatment === treatment.treatment_number + 1}
                            key={treatment.treatment_number + 1}
                          >
                            <div className="flex flex-col px-[10px] gap-[20px]">
                              <div className="px-2.5 self-stretch flex item-center gap-[40px]">
                                <CustomSpan
                                  className="font-medium text-gray-900 text-center"
                                  text={`処置${treatment.treatment_number}回目`}
                                />
                                <div className="flex items-center gap-[10px]">
                                  <FiUser size={20} className="font-medium" />
                                  <CustomSpan
                                    className="font-medium text-gray-900 text-center"
                                    text={treatment.treatment_user.name}
                                  />
                                </div>
                                <div className="flex items-center gap-[10px]">
                                  <FiCalendar size={20} className="font-medium" />
                                  <CustomSpan
                                    className="font-medium text-gray-900 text-center"
                                    text={formatDateTime(
                                      new Date(treatment.treatment_datetime)
                                    )}
                                  />
                                </div>
                              </div>
                              <div className="w-full relative rounded-lg border border-[#e0e0e0] overflow-y-auto" style={{
                                maxHeight: maxHeightTableTreatment[`tab_${treatment.treatment_number + 1}`] ? `${maxHeightTableTreatment[`tab_${treatment.treatment_number + 1}`]}px` : "auto"
                              }} ref={
                                tableTreatmentRef.current[`tab_${treatment.treatment_number + 1}`] ??
                                (tableTreatmentRef.current[`tab_${treatment.treatment_number + 1}`] = React.createRef())
                              }>
                                <Table className="no-drop-shadow-table" striped>
                                  <Table.Head className={`${maxHeightTableTreatment[`tab_${treatment.treatment_number + 1}`] ? 'sticky top-0 z-[8]' : ''} border-b border-tenken-gray-200`}>
                                    <Table.HeadCell className="!normal-case w-[2%] min-w-[75px] scrollable-table-header-bg">
                                      <span>No.</span>
                                    </Table.HeadCell>
                                    <Table.HeadCell className="px-1 max-w-[938px] scrollable-table-header-bg">
                                      <span className="whitespace-nowrap">
                                        点検項目
                                      </span>
                                    </Table.HeadCell>
                                    <Table.HeadCell className="px-1 scrollable-table-header-bg">
                                      <span className="whitespace-nowrap">
                                        判定基準
                                      </span>
                                    </Table.HeadCell>
                                    <Table.HeadCell className="px-1 scrollable-table-header-bg">
                                      <span className="whitespace-nowrap">
                                        下限
                                      </span>
                                    </Table.HeadCell>
                                    <Table.HeadCell className="px-1 scrollable-table-header-bg">
                                      <span className="whitespace-nowrap">
                                        上限
                                      </span>
                                    </Table.HeadCell>
                                    <Table.HeadCell className="px-1 scrollable-table-header-bg"></Table.HeadCell>
                                    <Table.HeadCell className="px-1 scrollable-table-header-bg">
                                      <span className="whitespace-nowrap">
                                        留意事項
                                      </span>
                                    </Table.HeadCell>
                                    <Table.HeadCell className="px-1 scrollable-table-header-bg">
                                      <span className="whitespace-nowrap">
                                        点検結果
                                      </span>
                                    </Table.HeadCell>
                                  </Table.Head>
                                  <Table.Body className="devide-y text-base break-all">
                                    {treatment?.treatment_items?.inspection_result_content.map(
                                      (itemResult, i) => (
                                        <TreatmentItemResultRow
                                          itemId={itemResult.inspection_item_id}
                                          items={inspectionItems}
                                          itemResult={itemResult}
                                          treatmentNumber={
                                            treatment.treatment_number
                                          }
                                          key={i}
                                        />
                                      )
                                    )}
                                  </Table.Body>
                                </Table>
                              </div>
                              <div className="flex flex-col bg-[#FFF] items-start self-stretch w-full xl:gap-[16px] gap-[12px]">
                                <Label
                                  className="font-medium"
                                  text="処置コメント"
                                />
                                <ReadonlyComment
                                  remarkText={
                                    treatment.treatment_number === 0
                                      ? null
                                      : treatment.remark_text
                                  }
                                  commentFiles={
                                    treatment.treatment_number === 0
                                      ? null
                                      : treatment.treatment_comment_files
                                  }
                                  className={
                                    treatment.treatment_number === 0
                                      ? "bg-[#EEE]"
                                      : ""
                                  }
                                />
                              </div>
                            </div>
                          </Tabs.Item>
                        ))}
                      </Tabs>
                    ) : inspectionDetails.inspection_result_ng ? (
                      <Tabs
                        style="underline"
                        theme={tenkenTheme.treatment_tabs}
                        onActiveTabChange={(tab) => setTabTreatment(tab + 1)}
                      >
                        <Tabs.Item title={`処置0回目`} active={tabTreatment === 1} key={1}>
                          <div className="flex flex-col px-[10px] gap-[20px]">
                            <div className="px-2.5 self-stretch flex item-center gap-[40px]">
                              <CustomSpan
                                className="font-medium text-gray-900 text-center"
                                text={`処置0回目`}
                              />
                              <div className="flex items-center gap-[10px]">
                                <FiUser size={20} className="font-medium" />
                                <CustomSpan
                                  className="font-medium text-gray-900 text-center"
                                  text={inspectionDetails?.execution_user.name}
                                />
                              </div>
                              <div className="flex items-center gap-[10px]">
                                <FiCalendar size={20} className="font-medium" />
                                <CustomSpan
                                  className="font-medium text-gray-900 text-center"
                                  text={formatDateTime(
                                    new Date(
                                      inspectionDetails?.registration_datetime
                                    )
                                  )}
                                />
                              </div>
                            </div>
                            <div className="w-full relative rounded-lg border border-[#e0e0e0] overflow-y-auto" style={{
                              maxHeight: maxHeightTableTreatment[`tab_1`] ? `${maxHeightTableTreatment[`tab_1`]}px` : "auto"
                            }} ref={
                              tableTreatmentRef.current[`tab_1`] ?? (tableTreatmentRef.current[`tab_1`] = React.createRef())
                            }>
                              <Table className="no-drop-shadow-table" striped>
                                <Table.Head className={`${maxHeightTableTreatment[`tab_1`] ? 'sticky top-0 z-[8]' : ''} border-b border-tenken-gray-200`}>
                                  <Table.HeadCell className="!normal-case w-[2%] min-w-[75px] scrollable-table-header-bg">
                                    <span>No.</span>
                                  </Table.HeadCell>
                                  <Table.HeadCell className="px-1 max-w-[938px] scrollable-table-header-bg">
                                    <span className="whitespace-nowrap">
                                      点検項目
                                    </span>
                                  </Table.HeadCell>
                                  <Table.HeadCell className="px-1 scrollable-table-header-bg">
                                    <span className="whitespace-nowrap">
                                      判定基準
                                    </span>
                                  </Table.HeadCell>
                                  <Table.HeadCell className="px-1 scrollable-table-header-bg">
                                    <span className="whitespace-nowrap">
                                      下限
                                    </span>
                                  </Table.HeadCell>
                                  <Table.HeadCell className="px-1 scrollable-table-header-bg">
                                    <span className="whitespace-nowrap">
                                      上限
                                    </span>
                                  </Table.HeadCell>
                                  <Table.HeadCell className="px-1 scrollable-table-header-bg"></Table.HeadCell>
                                  <Table.HeadCell className="px-1 scrollable-table-header-bg">
                                    <span className="whitespace-nowrap">
                                      留意事項
                                    </span>
                                  </Table.HeadCell>
                                  <Table.HeadCell className="px-1 scrollable-table-header-bg">
                                    <span className="whitespace-nowrap">
                                      点検結果
                                    </span>
                                  </Table.HeadCell>
                                </Table.Head>
                                <Table.Body className="devide-y text-base break-all">
                                  {inspectionDetails?.items.map(
                                    (itemResult, i) => (
                                      <TreatmentItemResultRow
                                        itemId={itemResult.inspection_item.id}
                                        items={inspectionItems}
                                        itemResult={itemResult}
                                        treatmentNumber={0}
                                        key={i}
                                      />
                                    )
                                  )}
                                </Table.Body>
                              </Table>
                            </div>
                            <div className="flex flex-col bg-[#FFF] items-start self-stretch w-full xl:gap-[16px] gap-[12px]">
                              <Label
                                className="font-medium"
                                text="処置コメント"
                              />
                              <ReadonlyComment className="bg-[#EEE]" />
                            </div>
                          </div>
                        </Tabs.Item>
                      </Tabs>
                    ) : (
                      <span className="flex justify-center items-center w-full text-tenken-gray-700 text-base lg:text-[18px]">
                        処置履歴なし
                      </span>
                    )}
                  </ExpandablePanel>

                  <ExpandablePanel title="判定結果">
                    {judgments[inspectionDetails.id]?.length > 0 ? (
                      <div className="relative rounded-lg border border-[#e0e0e0] w-full">
                        <Table className="no-drop-shadow-table" striped>
                          <Table.Head className="border-b border-tenken-gray-200">
                            <Table.HeadCell className="!normal-case w-[76px] !bg-white">
                              <span>No.</span>
                            </Table.HeadCell>
                            <Table.HeadCell className="w-[320px] !bg-white whitespace-nowrap">
                              <span>承認者</span>
                            </Table.HeadCell>
                            <Table.HeadCell className="w-[160px] !bg-white whitespace-nowrap">
                              <span>判定日</span>
                            </Table.HeadCell>
                            <Table.HeadCell className="w-[140px] !bg-white whitespace-nowrap">
                              <span>判定結果</span>
                            </Table.HeadCell>
                            <Table.HeadCell className="!bg-white">
                              <span>判定コメント</span>
                            </Table.HeadCell>
                          </Table.Head>
                          <Table.Body className="devide-y text-base">
                            {judgments[inspectionDetails.id].map(
                              (judgment, i) => (
                                <Table.Row
                                  key={1}
                                  className="odd:bg-gray-50 even:bg-white odd:dark:bg-gray-70 even:dark:bg-gray-800 border-b border-tenken-gray-200"
                                >
                                  <Table.Cell>
                                    <span>{i + 1}</span>
                                  </Table.Cell>
                                  <Table.Cell>
                                    <span>{judgment.judgment_user.name} ({judgment.judgment_user.username})</span>
                                  </Table.Cell>
                                  <Table.Cell>
                                    <span>
                                      {formatDate(judgment.judgment_datetime)}
                                    </span>
                                  </Table.Cell>
                                  <Table.Cell>
                                    <JudgmentResultText
                                      result={judgment.result}
                                    />
                                  </Table.Cell>
                                  <Table.Cell>
                                    <span className="whitespace-pre-wrap">
                                      {judgment.comment}
                                    </span>
                                  </Table.Cell>
                                </Table.Row>
                              )
                            )}
                          </Table.Body>
                        </Table>
                      </div>
                    ) : (
                      <span className="flex justify-center items-center w-full text-tenken-gray-700 text-base lg:text-[18px]">
                        判定履歴なし
                      </span>
                    )}
                  </ExpandablePanel>
                </div>
              </Tabs.Item>
            ))}
          </Tabs>
        </Modal.Body>
        <Modal.Footer className="bg-[#EEE] w-full">
          <Button
            color="gray"
            theme={tenkenTheme.button}
            className="mx-auto rounded-[6px] min-w-[300px] h-[44px]"
            onClick={() => {
              onClose();
              setShowModal(false);
            }}
          >
            戻る
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
}

export default ModalInspection;
